import React, { useEffect, useState } from "react";
import { downloadBackup, fetchBackups } from "../../services/backupService";

const fmtSize = (bytes) => {
  if (!bytes && bytes !== 0) return "-";
  const mb = bytes / (1024 * 1024);
  if (mb < 1024) return `${mb.toFixed(2)} MB`;
  return `${(mb / 1024).toFixed(2)} GB`;
};

export default function BackupsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await fetchBackups();
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setError("Impossible de charger les sauvegardes.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleDownload = async (filename) => {
    try {
      setDownloading(filename);
      await downloadBackup(filename);
    } catch (e) {
      setError("Téléchargement échoué.");
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Sauvegardes</h2>
      <p style={{ color: "#64748B" }}>
        Sauvegardes automatiques stockées sur le VPS. Téléchargement réservé aux administrateurs.
      </p>

      {error && (
        <div style={{ background: "#fee2e2", padding: 10, borderRadius: 6, marginBottom: 10 }}>
          {error}
        </div>
      )}

      <div style={{ marginBottom: 10 }}>
        <button onClick={load} disabled={loading} style={{ padding: "8px 12px" }}>
          {loading ? "Chargement..." : "Rafraîchir"}
        </button>
      </div>

      <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f8fafc" }}>
            <tr>
              <th style={{ textAlign: "left", padding: 10 }}>Date</th>
              <th style={{ textAlign: "left", padding: 10 }}>Fichier</th>
              <th style={{ textAlign: "right", padding: 10 }}>Taille</th>
              <th style={{ textAlign: "right", padding: 10 }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {!loading && items.length === 0 && (
              <tr>
                <td colSpan={4} style={{ padding: 12, color: "#64748B" }}>
                  Aucune sauvegarde trouvée.
                </td>
              </tr>
            )}

            {items.map((b) => {
              const dateStr = b.lastModified ? new Date(b.lastModified).toLocaleString() : "-";
              return (
                <tr key={b.filename} style={{ borderTop: "1px solid #e2e8f0" }}>
                  <td style={{ padding: 10 }}>{dateStr}</td>
                  <td style={{ padding: 10 }}>{b.filename}</td>
                  <td style={{ padding: 10, textAlign: "right" }}>{fmtSize(b.sizeBytes)}</td>
                  <td style={{ padding: 10, textAlign: "right" }}>
                    <button
                      onClick={() => handleDownload(b.filename)}
                      disabled={downloading === b.filename}
                      style={{ padding: "8px 12px" }}
                    >
                      {downloading === b.filename ? "Téléchargement..." : "Télécharger"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
